import { prettyErrorDescription } from 'constants/errors'
import { AxiosError } from 'axios'
import ChangePassword from 'components/form-information/password-recovery'
import { useCustomForm } from 'hooks/use-custom-form'
import useRouter from 'hooks/use-router'
import { useContext, useEffect, useState } from 'react'
import ProfileService from 'services/profile-services'
import ErrorView from 'components/error-view'
import useMainClass, { usePopupContext } from 'hooks/use-main-cass'
import CONFIGS from 'build/Config'
import toast from 'react-hot-toast'
import ResetPasswordV2 from 'components/forms/v2/ResetPassword'
import LoadingScreen from 'components/loading-screen'
import { LoaderContext } from '../../contexts/loader-context'

const PasswordReset = () => {
  const { state, handleChangeState } = useCustomForm({ step: 1, password: '', password_confirm: '' })
  const { setLoad } = useContext(LoaderContext)
  const [error, setError] = useState(null)
  const { push, search } = useRouter()
  const query = new URLSearchParams(search)
  const oobCode = query.get('oobCode')?.replace(/&$/i, '').replaceAll(' ', '+')
  useMainClass('login__password-reset')
  const { openPopup, closePopup } = usePopupContext()
  useEffect(() => {
    setLoad(true)
  }, [])

  const version = CONFIGS.versionPh || 'v1'

  const onSubmit = async (newPassword: string) => {
    setLoad(true)
    try {
      await ProfileService.doReset({ oobCode, newPassword })
      if (version === 'v2') {
        closePopup()
        toast.success('La contraseña se reseteó con éxito', { className: 'toast__success' })
      } else {
        push('/login')
      }
    } catch (err) {
      const typedError = err as AxiosError
      const { code } = typedError.response?.data || {}
      if (version === 'v2') {
        toast.error(prettyErrorDescription(code), { className: 'toast__error' })
      } else {
        setError(code)
      }
    } finally {
      setLoad(false)
    }
  }

  const verifyReset = async () => {
    try {
      const response = await ProfileService.verifyReset(JSON.stringify({ oobCode }))
      if (response.status === 200) {
        if (version !== 'v1') {
          openPopup(<ResetPasswordV2 onSubmit={onSubmit} />)
          push('/start')
        }
      } else {
        toast.error('Enlace invalido', { className: 'toast__error' })
        push('/start')
      }
    } catch (err) {
      toast.error('Enlace invalido', { className: 'toast__error' })
      push('/start')
    }
    finally {
      setLoad(false)
    }
  }

  useEffect(() => {
    verifyReset()
  }, [oobCode, history])

  if (version === 'v2') {
    return <LoadingScreen />
  }

  if (error) {
    return (
      <ErrorView code={error} buttonMenu={() => error(null)} onRetry={() => error(null)} />
    )
  }

  return (
    <div className={`flex w-full`}>
      <ChangePassword state={state} handleChange={handleChangeState} onSubmit={onSubmit} />
    </div>
  )
}

export default PasswordReset
